module.exports = __webpack_public_path__ + "img/steve-halama-T9A31lqrXnU-unsplash.79a18284.jpg";